import React from "react";

interface LayoutHeroProps {
    children?: React.ReactNode;
}

export const LayoutHero: React.FC<LayoutHeroProps> = ({ children }: LayoutHeroProps) => {
    return (
        <div className="layoutHero">
            <div className="contentCard">
                {children}
            </div>
        </div>
    );
};
